// extracted by mini-css-extract-plugin
module.exports = {"header":"FoodComboCardHeader_header__2kCqN"};